import classNames from 'classnames'
import React from 'react'
import './styles.scss'

export interface MobileFilterToggleProps {
  isOpen: boolean
  onToggle: () => void
  activeFiltersCount: number
  totalResultsCount: number
  className?: string
}

export const MobileFilterToggle: React.FC<MobileFilterToggleProps> = ({
  isOpen,
  onToggle,
  activeFiltersCount,
  totalResultsCount,
  className,
}) => {
  return (
    <button
      className={classNames('mobile-filter-toggle', {
        'mobile-filter-toggle--open': isOpen,
        [className || '']: !!className,
      })}
      onClick={onToggle}
      aria-expanded={isOpen}
      aria-label={`${isOpen ? 'Hide' : 'Show'} filters`}
    >
      <div className="mobile-filter-toggle__content">
        <div className="mobile-filter-toggle__icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" />
          </svg>
        </div>
        
        <div className="mobile-filter-toggle__text">
          <div className="mobile-filter-toggle__title">
            Filters {activeFiltersCount > 0 && `(${activeFiltersCount})`}
          </div>
          <div className="mobile-filter-toggle__subtitle">
            {totalResultsCount.toLocaleString()} sources
          </div>
        </div>
        
        <div className="mobile-filter-toggle__chevron">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </div>
      </div>
      
      {activeFiltersCount > 0 && (
        <div className="mobile-filter-toggle__badge">
          {activeFiltersCount}
        </div>
      )}
    </button>
  )
}